'use client';

import NumberFlow from '@number-flow/react';
import classnames from 'classnames';
import { FiArrowDownRight, FiArrowRight, FiArrowUpRight } from 'react-icons/fi';

import { Icon } from '../../icon';
import type { ValueChartProps } from './ValueChart.types';

import styles from './ValueChart.module.scss';

const DEFAULT_NUMBER_FORMAT = {
  notation: 'compact' as const,
  maximumFractionDigits: 2,
};

function ValueChart({
  style,
  className,
  value,
  trending,
  size = 'md',
  format,
  prefix,
  suffix,
  testId = 'ui-value-chart',
}: ValueChartProps) {
  const numberFormat = format || DEFAULT_NUMBER_FORMAT;

  return (
    <div
      style={style}
      className={classnames(styles['value-chart'], className)}
      data-testid={testId}
    >
      {trending && <span className={styles['spacer']} aria-hidden="true" />}
      <span
        className={classnames(
          styles['value'],
          size && styles[`value--${size}`],
        )}
      >
        <NumberFlow
          value={value}
          format={numberFormat}
          locales={['es']}
          prefix={prefix}
          suffix={suffix}
        />
      </span>
      {trending === 'up' && (
        <Icon
          size="xs"
          icon={<FiArrowUpRight />}
          className={classnames(
            trending && styles[`icon--${trending}`],
            className,
          )}
        />
      )}
      {trending === 'down' && (
        <Icon
          size="xs"
          icon={<FiArrowDownRight />}
          className={classnames(
            trending && styles[`icon--${trending}`],
            className,
          )}
        />
      )}
      {trending === 'equal' && (
        <Icon
          size="xs"
          icon={<FiArrowRight />}
          className={classnames(
            trending && styles[`icon--${trending}`],
            className,
          )}
        />
      )}
    </div>
  );
}

export { ValueChart };
